const { atom } = require("recoil");

export const targetListingState = atom({
  key: "targetListingState",
  default: [],
});

export const targetReloadState = atom({
  key: "targetReloadState",
  default: true,
});

export const showObjectivesModalState = atom({
  key: "showObjectivesModalState",
  default: {
    showModal: false,
    data: [],
  },
});
export const gridFiltersState = atom({
  key: "gridFiltersState",
  default: [],
});

export const templateListingState = atom({
  key: "templateListingState",
  default: [],
});

export const isFetchedState = atom({
  key: "isFetchedState",
  default: false,
});

export const archivedDetailTargetState = atom({
  key: "archivedDetailTargetState",
  default: false,
});

export const srsTargetState = atom({
  key: "srsTargetState",
  default: true,
});

export const generalCheckinLoaderState = atom({
  key: "generalCheckinLoaderState",
  default: false,
});

export const reviewAccordionState = atom({
  key: "reviewAccordionState",
  default: [],
});

export const assignPeopleDataState = atom({
  key: "assignPeopleDataState",
  default: {},
});

export const editAssignPeopleDataState = atom({
  key: "editAssignPeopleDataState",
  default: {},
});

export const weightageTypeState = atom({
  key: "weightageTypeState",
  default: "",
});

export const skillsAndStrengthsState = atom({
  key: "skillsAndStrengthsState",
  default: [],
});

export const linkedTargetState = atom({
  key: "linkedTargetState",
  default: [],
});

export const targetDetailsState = atom({
  key: "targetDetails",
  default: [],
});
export const targetArchiveState = atom({
  key: "targetArchiveState",
  default: false,
});
export const beforeRestoreDataState = atom({
  key: "beforeRestoreDataState",
  default: [],
});
export const viewTargetRatingState = atom({
  key: "viewTargetRatingState",
  default: [],
});

export const greenStripUsersState = atom({
  key: "greenStripUsersState",
  default: [],
});

export const usersToSubmitState = atom({
  key: "usersToSubmitState",
  default: [],
});

export const userListToRateState = atom({
  key: "userListToRateState",
  default: [],
});

export const targetHistoryState = atom({
  key: "targetHistoryState",
  default: [],
});

export const checkinFeedbackState = atom({
  key: "checkinFeedbackState",
  default: [],
});

export const userCheckinState = atom({
  key: "userCheckinState",
  default: [],
});

export const peopleRatingSubmitedState = atom({
  key: "peopleRatingSubmitedState",
  default: false,
});

export const checkinSRSSummeryState = atom({
  key: "checkinSRSSummeryState",
  default: [],
});

export const checkinSRSDetailsState = atom({
  key: "checkinSRSDetailsState",
  default: {},
});

export const templateModalPreviewState = atom({
  key: "templateModalPreviewState",
  default: {},
});

export const checkinFeedbackDetailsState = atom({
  key: "checkinFeedbackDetailsState",
});

export const targetReviewReloadState = atom({
  key: "targetReviewReloadState",
  default: false,
});

export const targetReviewMessageState = atom({
  key: "targetReviewMessageState",
  default: {},
});

export const markCompleteState = atom({
  key: "markCompleteState",
  default: false,
});

export const companyActivationDate = atom({
  key: "companyActivationDate",
  default: true,
});

export const chickinNotificationId = atom({
  key: "chickinNotificationId",
  default: "",
});

export const checkinsListLoadingState = atom({
  key: "checkinsListLoadingState",
  default: false,
});

export const openReviewState = atom({
  key: "openReviewState",
  default: false,
});
export const openCompletionReviewState = atom({
  key: "openCompletionReviewState",
  default: false,
});
export const actionPerformaceState = atom({
  key: "actionPerformaceState",
  default: "",
});
export const handleTargetDetailsState = atom({
  key: "handleTargetDetailsState",
  default: {},
});

export const menuListState = atom({
  key: "menuListState",
  default: [],
});

export const messageListState = atom({
  key: "messageListState",
  default: [],
});

export const showAnimationState = atom({
  key: "showAnimationState",
  default: false,
});

export const showSmackbarToastState = atom({
  key: "showSmackbarToastState",
  default: false,
});

export const objectiveNotificationId = atom({
  key: "objectiveNotificationId",
  default: "",
});

export const communcationUnreadMessageState = atom({
  key: "communcationUnreadMessageState",
  default: "{}",
});

export const loaderState = atom({
  key: "loaderState",
  default: false,
});

export const targetDetailState = atom({
  key: "targetDetailState",
  default: {},
});
export const checkinState = atom({
  key: "checkinState",
  default: [],
});
export const objectiveState = atom({
  key: "objectiveState",
  default: {},
});

export const modalState = atom({
  key: "modalState",
  default: false,
});

export const actionObjState = atom({
  key: "actionObjState",
  default: {},
});

export const submitLoaderState = atom({
  key: "submitLoaderState",
  default: false,
});

export const errorFieldState = atom({
  key: "errorFieldState",
  default: '',
});
